<template>
  <div class="container pb-100">
    <h2 class="section-title mb-30">Related Products</h2>
    <div class="shop-card-wrap style-one gx-0">
      <div
        class="shop-card position-relative"
        v-for="product in products"
        :key="product.id"
      >
        <div class="shop-promo style-one lh-1 position-absolute text-white">
          {{ product.state }}
        </div>
        <router-link class="add-to-cart position-absolute" to="/cart">
          <img src="../../assets/img/icons/cart.svg" alt="Image" />
        </router-link>
        <div class="shop-img overflow-hidden">
          <img
            :src="product.image"
            alt="Image"
            class="d-block mx-auto transition"
          />
        </div>
        <div
          class="shop-info d-flex align-items-center justify-content-between"
        >
          <div>
            <ul class="ratings list-style">
              <li><i class="ri-star-s-fill"></i></li>
              <li><i class="ri-star-s-fill"></i></li>
              <li><i class="ri-star-s-fill"></i></li>
              <li><i class="ri-star-s-fill"></i></li>
              <li><i class="ri-star-s-fill"></i></li>
            </ul>
            <h3 class="fs-20">
              <router-link to="/product-details">
                {{ product.title }}
              </router-link>
            </h3>
            <router-link to="/shop-left-sidebar" class="shop-cat">
              {{ product.category }}
            </router-link>
          </div>
          <span class="fs-20 fw-bold f-secondary text_primary">
            ${{ product.price }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "RelatedProducts",
  data() {
    return {
      products: [
        {
          id: 1,
          state: "Sale",
          image: require("../../assets/img/shop/shop-1.webp"),
          title: "Thin can Mockup",
          category: "BRANDING",
          price: "67",
        },
        {
          id: 2,
          state: "Sale",
          image: require("../../assets/img/shop/shop-2.webp"),
          title: "Mac Coffee",
          category: "Drink",
          price: "45",
        },
        {
          id: 3,
          state: "",
          image: require("../../assets/img/shop/shop-3.webp"),
          title: "Pure Honey",
          category: "Food",
          price: "120",
        },
      ],
    };
  },
});
</script>